export enum ContactAction {
  EDIT = 'edit-contact',
  MOVE = 'move-contact',
  DUPLICATE = 'duplicate-contact',
  DELETE = 'delete-contact',
}

export enum ContactGroupAction {
  RENAME = 'rename-group',
  DELETE = 'delete-group',
}
